<template>
  <span class="scaling-svg-container">
    <svg
      data-name="Icon/Arrow Down"
      xmlns="http://www.w3.org/2000/svg"
      width="12.579"
      height="14.376"
      viewBox="0 0 12.579 14.376"
      class="scaling-svg"
    >
      <path
        data-name="Icon/Icon/Arrow-down"
        d="M12.371,8.41a.9.9,0,0,0-1.265-.115L7.188,11.559V.9a.9.9,0,0,0-1.8,0V11.559L1.474,8.295a.9.9,0,1,0-1.15,1.38l5.391,4.492a.859.859,0,0,0,.139.08.825.825,0,0,0,.11.063.844.844,0,0,0,.652,0,.825.825,0,0,0,.11-.063.859.859,0,0,0,.139-.08l5.391-4.492a.9.9,0,0,0,.115-1.265"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ArrowMoveDownIcon extends Vue {}
</script>

<style>
</style>
